import "./styles/button.css"
import React from "react";

const renderButton = (type, text, action, icon) => {
    let className = type ? `button ${type}`: "button default primary";
    let textToDisplay = text || icon ? text : "Button"; 

    return (
        type === "disabled" ? (
                <button className={className} onClick={action} disabled={true}>
                    {icon && <span className="icon">{icon}</span>}
                    {textToDisplay}
                </button>  
        )
        : (
            <button className={className} onClick={action}>
                {icon && <span className="icon">{icon}</span>}
                {textToDisplay}
            </button>  
        )
    );
};


const Button = ({type, text, onClickAction, icon}) =>{
    return(
        <>
            {renderButton(type, text, onClickAction, icon)}
        </>
    );
}

export default Button;